module.exports = __webpack_public_path__ + "static/media/christopher_headshot.9d3e93d4.jpeg";